export default __webpack_public_path__ + "static/media/baby.e57e4178.svg";